import React from "react";
import { Box } from "@mui/material";

interface SegmentedBarProps {
  zero: boolean;
  one: boolean;
  two: boolean;
  three: boolean;
  four: boolean;
}

const SegmentedBar: React.FC<SegmentedBarProps> = ({
  zero,
  one,
  two,
  three,
  four,
}) => {
  const segmentStyle = {
    width: 92,
    height: 8,
    borderRadius: 4,
  };

  const gapStyle = {
    width: 8,
    height: 8,
    backgroundColor: "transparent",
  };

  const getSegmentColor = (isActive: boolean) => ({
    backgroundColor: isActive ? "#FFFFFF" : "#667085",
  });

  return (
    <Box
      display="flex"
      flexDirection="row"
      height={8}
      justifyContent="space-between"
    >
      <Box
        style={{
          ...segmentStyle,
          ...getSegmentColor(one || two || three || four),
        }}
      />
      <Box style={gapStyle} />
      <Box
        style={{
          ...segmentStyle,
          ...getSegmentColor(two || three || four),
        }}
      />
      <Box style={gapStyle} />
      <Box style={{ ...segmentStyle, ...getSegmentColor(three || four) }} />
      <Box style={gapStyle} />
      <Box
        style={{
          ...segmentStyle,
          ...getSegmentColor(four),
        }}
      />
    </Box>
  );
};

export default SegmentedBar;
